function isEqual(valueA, valueB) {
  return (
    valueA?.value === valueB?.value &&
    valueA?.currency === valueB?.currency &&
    valueA?.symbol === valueB?.symbol
  );
}

export default isEqual;
